import { useQuery } from '@tanstack/react-query'
import { playFetch } from '@/lib/phishtrainer/play-api'
import { playKeys } from '@/lib/phishtrainer/query-keys'
import type { LeaderboardRow } from '@/components/phishtrainer/me/leaderboard-card'

// ============ Types ============

interface LeaderboardResponse {
  top?: LeaderboardRow[]
  pinned?: LeaderboardRow | null
}

export interface PlayLeaderboard {
  top: LeaderboardRow[]
  pinned: LeaderboardRow | null
}

// ============ Query Hooks ============

/**
 * The play-realm leaderboard. Goes straight to the BE play endpoint via
 * playFetch — the /api/phishtrainer leaderboard proxy is ADMIN-only and returned
 * an empty board for learners.
 *
 * Normalizes `{top?, pinned?}` into guaranteed shapes so consumers index them
 * directly.
 */
export function usePlayLeaderboard(limit = 50, enabled = true) {
  return useQuery({
    queryKey: playKeys.leaderboard({ limit }),
    queryFn: () => playFetch<LeaderboardResponse>(`leaderboard?limit=${limit}`),
    select: (res: LeaderboardResponse): PlayLeaderboard => ({
      top: res.top ?? [],
      pinned: res.pinned ?? null,
    }),
    enabled,
  })
}
